export const businessVerificationCarrierReviews = [
    "none",
    "inReview",
    "rejected",
    "approved",
];
const decisions = {
    none: null,
    inReview: null,
    rejected: "rejected",
    approved: "approved",
};
export const businessVerificationDecision = (carrierReview) => decisions[carrierReview];
export const businessVerificationSettingsPath = "/settings/integrations/business-verification";
export const businessVerificationStatuses = [
    "draft",
    "inReview",
    "needsAttention",
    "verified",
];
const submittedStatus = {
    none: "inReview",
    inReview: "inReview",
    rejected: "needsAttention",
    approved: "verified",
};
export const businessVerificationStatus = (profileStatus, carrierReview) => profileStatus === "draft" ? "draft" : submittedStatus[carrierReview];
//# sourceMappingURL=business-verification-status.js.map